import { Button, Result, Space } from "antd";
import { Component, ErrorInfo, ReactNode } from "react";
import { HomeOutlined, ReloadOutlined } from "@ant-design/icons";

interface Props {
  children?: ReactNode;
  fallback: ReactNode;
}

interface State {
  error: Error | undefined;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    error: undefined,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.error?.message.includes("401")) {
      return this.props.fallback;
    }

    if (this.state.error) {
      return (
        <Result
          status="warning"
          title="There are some problems with your operation."
          extra={
            <Space>
              <Button icon={<HomeOutlined />} key="console" href={"/"}>
                home
              </Button>
              <Button icon={<ReloadOutlined />} type="primary" key="console" onClick={() => window.location.reload()}>
                refresh
              </Button>
            </Space>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
